import { caseInsensitiveEquals } from "../../../utils/number.js";
import { VariantSelectorBase } from "./variant-selector-base.js";

const $ = window.jQuery;
const pubsub = window.PubSub;

export abstract class TilesVariantSelectorBase extends VariantSelectorBase {
    protected $variants: any;

    protected processAfterRender() {
        const self = this;
        const $selectorContainerElement = $(self.selectorContainerElement);

        $selectorContainerElement.on('click', function (evt: Event) {
            evt.preventDefault();
            $(this).toggleClass('active');
        });

        self.$variants = $selectorContainerElement.find('.js-variant');
        self.$variants.on('click', function (evt: Event) {
            evt.preventDefault();

            var $variantToSelect = $(this);
            self.setSelectedInternal($variantToSelect);
        });

        pubsub.publish('variantprocessor.variant.render', { variant: self.variantSelectorData, container: $selectorContainerElement });
    }

    public setSelected(variantId: string): void {
        var $variantToSelect = this.$variants.filter('[data-variantid="' + variantId + '"]');
        var isVariantAlreadySelected = $variantToSelect.hasClass('selected');

        if (!isVariantAlreadySelected && $variantToSelect.length === 1) {
            this.setSelectedInternal($variantToSelect);
        }
    }

    public setSelectedByName(variantValueName: string): void {
        if (variantValueName) {
            const foundVariantValue = this.variantType.variants.find(function (currentVariant) {
                return caseInsensitiveEquals(currentVariant.name, variantValueName);
            });

            if (foundVariantValue) {
                this.setSelected(foundVariantValue.id.toString());
            }
        }
    }

    public getSelected(): number {
        var $selected = this.$variants.filter('.selected');
        return $selected.data('variantid') || 0;
    }

    public filterVariants(unavailableVariants: any, preselectSingleAvailable: any): void {
        const self = this;
        var $singleAvailableVariant;

        this.$variants.each(function () {
            var $this = $(this);
            var $unavailable = $this.find('.js-unavailable-text');
            var variantId = $this.data('variantid');

            if (variantId <= 0) {
                return; // Default option
            }

            const unavailableVariant = unavailableVariants[variantId];

            if (unavailableVariant) {
                if (unavailableVariant.exists === false) {
                    $this.hide();
                } else {
                    $this.addClass('disabled');

                    if (unavailableVariant.disabled) {
                        $this.attr('disabled', 'disabled');
                    } else {
                        $this.removeAttr('disabled');
                    }

                    if (unavailableVariant.message) {
                        $unavailable.html(unavailableVariant.message);
                        $unavailable.closest('.js-unavailable-text-container').show();
                        $this.attr('title', unavailableVariant.message);
                    }

                    $this.show();
                }
            } else {
                $this.removeClass('disabled');
                $this.removeAttr('disabled');

                $unavailable.html('');
                $unavailable.closest('.js-unavailable-text-container').hide();
                $this.removeAttr('title');
                $this.show();

                $singleAvailableVariant = typeof ($singleAvailableVariant) === 'undefined' ? $this : null;
            }
        });

        // ReSharper disable once CoercedEqualsUsing
        if ($singleAvailableVariant && preselectSingleAvailable) {
            var currentValue = self.getSelected();
            var newValue = $singleAvailableVariant.data('variantid');
            if (currentValue != newValue) {
                self.setSelected($singleAvailableVariant);
            }
        }
    }

    public processVariants(variantTypeToProductInfoMap: any): void {
        this.$variants.each(function () {
            var $this = $(this);
            var variantId = $this.data('variantid');

            if (variantId <= 0) {
                return; // Default option
            }

            var productInfo = variantTypeToProductInfoMap[variantId];
            if (productInfo && productInfo.discountInfo.isOutlet) {
                var replaceEmptyString = productInfo.discountInfo.flagName.replace(/\s+/g, "-").toLowerCase();
                $this.addClass(replaceEmptyString + ' flag-' + productInfo.discountInfo.flagId + '-' + replaceEmptyString);
            }
        });
    }

    protected setSelectedInternal($variantToSelect: any): void {
        const $selectorContainerElement = $(this.selectorContainerElement);
        var isVariantAlreadySelected = $variantToSelect.hasClass('selected');

        this.$variants.removeClass('selected');

        var currentVariantValue = null;
        if (!isVariantAlreadySelected) {
            $variantToSelect.addClass('selected');
            currentVariantValue = $variantToSelect.data('variantid');
        }

        var isSelectedOptionAvailable = this.isSelectedAvailable();
        $selectorContainerElement.trigger(this.VARIANT_CHANGED_EVENT, [this.variantType, currentVariantValue || 0, isSelectedOptionAvailable, this.product.productId]);

        this.setVariantSelectorLabelPrefix(this.getSelected() > 0
            ? this.variantSelectorData.labels.changeSelection
            : this.variantSelectorData.labels.select);
    }

    protected isSelectedAvailable() {
        var $selected = this.$variants.filter('.selected');

        // Default option (or unselected state) should be marked as available. Otherwise, unavailable variants filtering will not happen on deselection.
        return $selected.length === 0 || $selected.is(':not(.disabled)');
    }

    protected setVariantSelectorLabelPrefix(prefix) {
        const $selectorContainerElement = $(this.selectorContainerElement);
        var $variantSelectorLabel = $selectorContainerElement.find('.js-select-variant-label');
        $variantSelectorLabel.text(`${prefix} ${this.variantSelectorData.variantTypeName}`);
    }
}
